"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7220],{

/***/ 27220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WorkingWithUs; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/WorkingWithUs/workingWithUs.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: 18.75rem auto 18.75rem;\n    grid-template-rows: minmax(0, 1fr) 163px minmax(0, 1fr);\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1u6222d0"
})("background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";padding-top:5.5rem;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e1u6222d1"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:3rem;font-style:normal;font-weight:400;line-height:3.5rem;text-align:left;", mixins/* defaultContainerSize */.sX, ";");
const SectionContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1u6222d2"
})(mixins/* defaultContainerSize */.sX, ";padding-top:4rem;padding-bottom:5rem;display:flex;flex-direction:column;flex:1;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const SectionContainerTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1u6222d3"
})(Typography/* Headline4 */.Ou, ";letter-spacing:0;text-align:left;");
const SectionContainerDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1u6222d4"
})(Typography/* ParagraphS */.fw, ";letter-spacing:0.013rem;text-align:left;");
const SectionContainerTopLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1u6222d5"
})("grid-column-start:1;grid-column-end:1;grid-row-start:1;grid-row-end:1;");
const SectionContainerTopRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1u6222d6"
})("grid-column-start:3;grid-column-end:3;grid-row-start:1;grid-row-end:1;");
const SectionContainerBottomLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1u6222d7"
})("grid-column-start:1;grid-column-end:1;grid-row-start:3;grid-row-end:3;");
const SectionContainerBottomRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1u6222d8"
})("grid-column-start:3;grid-column-end:3;grid-row-start:3;grid-row-end:3;");
const SectionContainerImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1u6222d9"
})("grid-column-start:2;grid-column-end:2;grid-row-start:1;grid-row-end:4;display:flex;justify-content:center;align-items:center;height:100%;");

;// CONCATENATED MODULE: ./components/sections/WorkingWithUs/WorkingWithUs.tsx





const WorkingWithUs = (param)=>{
    let { title , topLeftTitle , topLeftDescription , topRightTitle , topRightDescription , bottomLeftTitle , bottomLeftDescription , bottomRightTitle , bottomRightDescription , contentImage , contentImageXs , titleAs  } = param;
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                as: titleAs,
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainerTopLeft, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerTitle, {
                                children: topLeftTitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerDescription, {
                                children: topLeftDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainerTopRight, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerTitle, {
                                children: topRightTitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerDescription, {
                                children: topRightDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainerBottomLeft, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerTitle, {
                                children: bottomLeftTitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerDescription, {
                                children: bottomLeftDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainerBottomRight, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerTitle, {
                                children: bottomRightTitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContainerDescription, {
                                children: bottomRightDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainerImage, {
                        children: [
                            width > 1200 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                ...(0,imageSerializer/* imageSerializer */.l)(contentImage)
                            }),
                            width <= 1200 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                ...(0,imageSerializer/* imageSerializer */.l)(contentImage)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/WorkingWithUs/index.ts

/* harmony default export */ var sections_WorkingWithUs = (WorkingWithUs);


/***/ })

}]);